import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTABar from "@/components/MobileCTABar";
import CentreModal from "@/components/CentreModal";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <CentreModal />
      <main className="pb-16 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
}
